package app.bloomey.web.modules.users

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.PageResponse
import app.bloomey.web.core.data.models.UpdateUserRequest
import app.bloomey.web.core.data.models.User

object UsersContract {
    data class State(
        val usersState: UiState<PageResponse<List<User>>> = UiState.Initial,
        val page: Int = 1,
        val updateUser: UiState<User> = UiState.Initial,
        val deleteUsers: UiState<String> = UiState.Initial,
        val deleteUser: UiState<Boolean> = UiState.Initial,
        val getUser: UiState<User> = UiState.Initial,
    )

    sealed interface Inputs {
        data class GetUsers(val page: Int, val size: Int, val query: String) : Inputs
        data class GetUser(val userId: String) : Inputs
        data class UpdateUser(val id: String, val request: UpdateUserRequest) : Inputs
        data class DeleteUsers(val idList: List<String>) : Inputs
        data class DeleteUser(val id: String) : Inputs
    }

    sealed interface Events
}
